import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SVG from 'components/base/SVG';
import { dropdownable } from 'components/base/Dropdown';

import css from './style.scss';

const InlineDropdown = ({
  isOpen,
  onClick,
  items,
  selectedValue,
  dropdownClassName,
  className,
  closeDropdown,
  onSelect
}) => {
  const handleClick = (item) => {
    closeDropdown();

    if (onSelect) {
      onSelect(item);
    }
  };

  // Find the selected item to display
  const selectedItem = items.find(item => item.value === selectedValue) || items[0];

  return (
    <div
      className={classNames(css.inlineDropdown, className, { [css.open]: isOpen })}
      onClick={onClick}
    >
      <div className={css.trigger}>
        <span className={css.selectedText}>{selectedItem?.label}</span>
        {/* <SVG icon="iconCaretDown" className={css.iconCaretDown} /> */}
        <SVG
          icon={isOpen ? "dropdownopen" : "dropdownclosed"}
          className={css.iconCaretDown}
        />
      </div>

      <div className={classNames(css.dropdown, dropdownClassName)}>
        {items.map(item => (
          <div
            key={item.value}
            className={classNames(css.item, {
              [css.selected]: item.value === selectedValue
            })}
            onClick={() => handleClick(item)}
          >
            {item.label}
          </div>
        ))}
      </div>
    </div>
  );
};

InlineDropdown.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
  })).isRequired,
  selectedValue: PropTypes.any,
  onSelect: PropTypes.func,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  closeDropdown: PropTypes.func,
  dropdownClassName: PropTypes.string,
  className: PropTypes.string,
};

InlineDropdown.defaultProps = {
  selectedValue: null,
  onSelect: () => { },
  isOpen: false,
  onClick: () => { },
  closeDropdown: () => { },
};

export default dropdownable(InlineDropdown);
